const handleClickShowProfileDropdown = () => {
  document.getElementById("profile-dropdown").classList.toggle("show");
}

const changeStateMenuClosed = () => {
  if (localStorage.getItem("menuClosed") && localStorage.getItem("menuClosed") === "true") {
    localStorage.removeItem("menuClosed");
    document.body.classList.remove('mini-sidebar');
  } else {
    localStorage.setItem("menuClosed", true);
    document.body.classList.add('mini-sidebar');
  }
}

const setClassLeftSidebar = () => {
  if (localStorage.getItem("menuClosed") && localStorage.getItem("menuClosed") === "true") {
    document.body.classList.add('mini-sidebar'); 
  } else {
    document.body.classList.remove('mini-sidebar');
  }
}

const setOpenedOrClosedSubmenu = () => {
  let element_li = document.getElementById("item-with-submenu");
  if(element_li.classList.contains("active")){
    element_li.classList.remove("active");
    document.getElementById("sidebar-nav-submenu").classList.remove("in");
  }else{
    element_li.classList.add("active");
    document.getElementById("sidebar-nav-submenu").classList.add("in");
  }
}


export {
  handleClickShowProfileDropdown,
  changeStateMenuClosed,
  setClassLeftSidebar,
  setOpenedOrClosedSubmenu
}
